import axios from 'axios';

import { API } from '@/config/constants';
import { requireLocalBackendUrl } from './localBackend';


export const getSources = async (config) => {
  const response = await axios.get(`${API}/sources`, ...(config ? [config] : []));
  return response.data;
};

// All Orders' offline choices come from the accepted protected local catalog,
// never the cloud catalog-management endpoint (which desktop mode denies).
export const getDesktopSourceOptions = async (config) => {
  const localBackendUrl = requireLocalBackendUrl();
  const response = await axios.get(`${localBackendUrl}/api/desktop/source-options`, ...(config ? [config] : []));
  return response.data;
};

export const createSource = async (data, config) => {
  const response = await axios.post(`${API}/sources`, data, ...(config ? [config] : []));
  return response.data;
};

export const updateSource = async (sourceId, data, config) => {
  const response = await axios.put(`${API}/sources/${sourceId}`, data, ...(config ? [config] : []));
  return response.data;
};

// Priced on the server so the editor's preview and the dashboard's net come
// from one implementation. Reads nothing and writes nothing.
export const previewSourceDeduction = async (payload, config) => {
  const response = await axios.post(`${API}/sources/deduction-preview`, payload, ...(config ? [config] : []));
  return response.data;
};

export const deleteSource = async (sourceId, data, config) => {
  const response = await axios.delete(`${API}/sources/${sourceId}`, {
    ...config,
    data: data || undefined,
  });
  return response.data;
};

export const getSendingFlorists = async (config) => {
  const response = await axios.get(`${API}/sending-florists`, ...(config ? [config] : []));
  return response.data;
};

export const createSendingFlorist = async (data, config) => {
  const response = await axios.post(`${API}/sending-florists`, data, ...(config ? [config] : []));
  return response.data;
};

export const updateSendingFlorist = async (floristId, data, config) => {
  const response = await axios.put(`${API}/sending-florists/${floristId}`, data, ...(config ? [config] : []));
  return response.data;
};

export const deleteSendingFlorist = async (floristId, config) => {
  const response = await axios.delete(`${API}/sending-florists/${floristId}`, ...(config ? [config] : []));
  return response.data;
};

export const getSubsourceMappings = async (config) => {
  const response = await axios.get(`${API}/subsource-mappings`, ...(config ? [config] : []));
  return response.data;
};

export const updateSubsourceMapping = async (mappingId, sendingFloristId, config) => {
  const response = await axios.put(`${API}/subsource-mappings/${mappingId}`, {
    sending_florist_id: sendingFloristId || null,
  }, ...(config ? [config] : []));
  return response.data;
};

export const deleteSubsourceMapping = async (mappingId, config) => {
  const response = await axios.delete(`${API}/subsource-mappings/${mappingId}`, ...(config ? [config] : []));
  return response.data;
};

export const getSourceMappings = async (config) => {
  const response = await axios.get(`${API}/source-mappings`, ...(config ? [config] : []));
  return response.data;
};

export const updateSourceMapping = async (mappingId, sourceId, config) => {
  const response = await axios.put(`${API}/source-mappings/${mappingId}`, {
    source_id: sourceId || null,
  }, ...(config ? [config] : []));
  return response.data;
};

export const deleteSourceMapping = async (mappingId, config) => {
  const response = await axios.delete(`${API}/source-mappings/${mappingId}`, ...(config ? [config] : []));
  return response.data;
};

const mappingOrdersPath = (mappingType) => {
  if (mappingType === 'source-mappings' || mappingType === 'subsource-mappings') {
    return mappingType;
  }
  throw new Error(`Unsupported mapping type: ${mappingType}`);
};

export const getMappingOrders = async (mappingType, mappingId, params, config) => {
  const response = await axios.get(
    `${API}/${mappingOrdersPath(mappingType)}/${mappingId}/orders`,
    { ...config, params },
  );
  return response.data;
};
